import { post, get, put } from '@/utils/request';

export const SearchCar = (data) => get('/common/search/car', data)

export const SearchDriver = (data) => get('/common/search/driver', data)



